export enum SampleActions {
  OPEN_SAMPLE_DETAILS,
  CLOSE_MODAL,
  CLOSE_DIALOG,
  OPEN_MODAL,
  SELECT,
}
